import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';

@Component({
    selector: 'app-plan-success',
    templateUrl: './plan-success.component.html',
    styleUrls: ['./plan-success.component.scss']
})
export class PlanSuccessComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PlanSuccessComponent>,
        public trackingService: TrackingService) {
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
}
